'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const PlusIcon: TSVGIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 455 455',
  path: <path d='M455 212.5H242.5V0h-30v212.5H0v30h212.5V455h30V242.5H455z' />,
});
